/**
 * プロジェクトメッセージ / ショットコメント / DM メッセージの「単体取得」レスポンスは、
 * BE 実装の都合で以下のいずれかの形状で返ってくる可能性がある:
 *   - `{ status, data: <entity> }`                 （POST と同じ素直な形）
 *   - `{ status, data: { message: <entity> } }`   （PATCH と同じ形）
 *   - `{ status, data: { comment: <entity> } }`   （ショットコメントの PATCH 相当）
 *
 * FE 側で形状を仮定するとリアルタイム更新の取りこぼしに直結するため、
 * 実行時に広く許容できる取り出しユーティリティを用意する。
 */
export const extractDetailEntity = <T extends { id?: string | number }>(
  res: unknown,
): T | null => {
  if (!res || typeof res !== "object") return null;
  const root = res as Record<string, unknown>;
  const data = root.data;
  if (!data) return null;

  // ケース1: data 自体がエンティティ。
  if (typeof data === "object" && data !== null) {
    const dataObj = data as Record<string, unknown>;
    if (typeof dataObj.id === "string" || typeof dataObj.id === "number") {
      return dataObj as T;
    }
    // ケース2: data.message / data.comment にエンティティが入っている。
    for (const key of ["message", "comment"]) {
      const nested = dataObj[key];
      if (
        nested &&
        typeof nested === "object" &&
        (typeof (nested as Record<string, unknown>).id === "string" ||
          typeof (nested as Record<string, unknown>).id === "number")
      ) {
        return nested as T;
      }
    }
  }
  return null;
};
